import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Sire } from '@/rtk-query.gql';

import { EditSireForm, EditSireFormValues } from '../edit-sire-form';

type EditSireDialogProps = {
  visible: boolean;
  onHide: () => void;
  sire?: Sire;
  onSave?: (data: EditSireFormValues) => void;
  onError?: (error: unknown) => void;
};

export const EditSireDialog = ({
  visible,
  onHide,
  sire,
  onSave,
  onError,
}: EditSireDialogProps) => {
  const { t } = useTranslation();
  const [dialogContainer, setDialogContainer] = useState<HTMLElement | null>(
    null,
  );

  return (
    <Dialog
      open={visible}
      onOpenChange={(open) => {
        if (!open) onHide();
      }}
    >
      <DialogContent
        ref={setDialogContainer}
        className="z-[2000] md:max-w-[1000px]"
        overlayClassName="z-[2000]"
      >
        <DialogHeader>
          <DialogTitle>{t('sire.editSire')}</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <EditSireForm
            onCancel={onHide}
            sire={sire}
            onSuccess={onSave}
            onError={onError}
            calendarContainer={dialogContainer ?? undefined}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
};
